// extracted by mini-css-extract-plugin
export var standaloneTable = "_fm-0";
export var standaloneTableWithBodyFill = "_fm-1";
export var withExtraHeader = "_fm-2";